<script lang="ts" setup>
import { ref, computed } from "vue";
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from "chart.js";
import { Bar } from "vue-chartjs";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const props = defineProps({
  chartData: {},
  options: {},
  style: Object || null,
});

const chartOptions = computed(() => {
  const opt = {
    ...props.options,
    responsive: false,
    maintainAspectRatio: false,
    resizeDelay: 200,
    indexAxis: "y",
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        display: false,
      },
    },
    animation: {
      duration: 500,
      easing: "easeOutQuart",
      // Apply animation only to specific properties
      animateResize: true,
      onComplete: function () {},
    },
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        callbacks: {
        label: function(tooltipItem) {
            const datasetLabel = tooltipItem.dataset.label || '';
            const index = tooltipItem.dataIndex;
            const sumDataValue = tooltipItem.dataset.sumData[index];
            return `${datasetLabel}: ${sumDataValue}`;
            }
        }
      },
      legend: {
        onClick: (e, legendItem, legend) => {
          const datasetIndex = legendItem.datasetIndex;
          const chart = legend.chart;

          // Toggle visibility for the clicked dataset only
          chart.data.datasets[datasetIndex].hidden = !chart.data.datasets[datasetIndex].hidden;

          // Update the chart to reflect changes without using x-axis animation.
          chart.update({
            duration: 500,
            easing: "easeOutQuart",
            lazy: false, // Perform the animation immediately
            elements: {
              bar: {
                animation: {
                  properties: ["width", "opacity"],
                  duration: 500,
                  easing: "easeOutQuart",
                },
              },
            },
          });
        },
      },
    },
  };

  return opt;
});

const chartStyle = computed(() => {
  return (
    props.style ?? {
      height: "150px",
      width: "100%",
      marginLeft: "auto",
      marginRight: "auto",
      position: "relative",
    }
  );
});

const resizeKey = ref(0);

function onResize() {
  //console.log("advanced-horizontal-bar-chart resize ", resizeKey.value);
  //bar strecht de canvas ipv opnieuw tekenen, dus redrwar forceren
  resizeKey.value++;
}
</script>
<template>
  <div v-resize="onResize">
    <Bar :key="resizeKey" :data="chartData" :options="chartOptions" :style="chartStyle"></Bar>
  </div>
</template>
